export default __webpack_public_path__ + "a21fbb03e7c423e5731c0414db44d67a.png";